import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./Accordion.scss"; // optional styling
import AssignsymbolPopup from "./AssignsymbolPopup";
import CustomModal from "../CustomModal";
import "../AssignSymbols/assignSymbols.scss";
import sixDotIcon from "../../images/6doticon.svg";

const AccordionItem = ({
  title,
  content,
  isOpen,
  onClick,
  claim,
  editor,
  customDrag,
  setClaimsOnEditorAsset,
  claimsOnEditorAsset,
  moduleClaimsData,
  item,
  setRelatedClaimsData,
  relatedClaimsData,
  assignedSymbols,
  setPreviewLoading,
  setAssignedSymbols,
  previewLoading,
}) => {
  const [OpenAssignPopup, setOpenAssignPopup] = useState(false);
  const [appliedSymbol, setAppledSymbol] = useState(null);
  const [condition, setCondition] = useState(false); // added to re-render

  const footnoteSymbols = [
    "*",
    "†",
    "€",
    "¶",
    "§",
    "#",
    "@",
    "$",
    "!",
    "‡",
    "||",
    "µ",
    "¥",
    "^",
    "~",
    "**",
    "***",
    "£",
    "▼",
    "△",
    "®",
    //"╪",
    "ǂ",
    "I",
    "II",
    "III",
    "IV",
    "V",
    "VI",
    "VII",
    "VIII",
    "IX",
    "X",
  ];
  const exceptionSymbols = ["*", "**", "***"];
  const obj = {
    relatedClaimId: item.claimName,

    claimId: claim.claimName,
    moduleId: moduleClaimsData?.moduleDamName,
  };

  useEffect(() => {
    // console.log("on close called", relatedClaimsData, condition);
    // setRelatedClaimsData(assignedSymbols);
    const claimExistArray = relatedClaimsData?.findIndex(
      (exist_claim) =>
        exist_claim.relatedClaimId === obj.relatedClaimId &&
        exist_claim.moduleId === obj.moduleId
    );
    if (claimExistArray > -1 && relatedClaimsData.length > 0) {
      const symb = relatedClaimsData[claimExistArray]?.symbol;
      setAppledSymbol(symb);
    }
    setAssignedSymbols(relatedClaimsData);
  }, [appliedSymbol]);

  useEffect(() => {
    // setRelatedClaimsData(assignedSymbols);
    // console.log(
    //   "---------------------------------------------------",
    //   relatedClaimsData
    // );
    const claimExistArray = assignedSymbols?.findIndex(
      (exist_claim) =>
        exist_claim.relatedClaimId === obj.relatedClaimId &&
        exist_claim.moduleId === obj.moduleId
    );
    /*  if (moduleExist > -1) {
      const claimExist = assignedSymbols[moduleExist].moduleClaims.findIndex(
        (claim) => claim.moduleClaimId === obj.claimId
      );
      if (claimExist > -1) {
        const reClaimExist = assignedSymbols[moduleExist].moduleClaims[
          claimExist
        ].relatedClaims.findIndex(
          (re_claim) => re_claim.relatedClaimId === obj.relatedClaimId
        );
        if (reClaimExist > -1) {
          const sym =
            assignedSymbols[moduleExist].moduleClaims[claimExist].relatedClaims[
              reClaimExist
            ].symbol;
          console.log(
            "=====================symbol got",
            sym,
            assignedSymbols[moduleExist].moduleClaims[claimExist].relatedClaims[
              reClaimExist
            ]
          );
          setAppledSymbol(sym);
        } else {
        }
      }
    } */
    if (claimExistArray > -1 && assignedSymbols.length > 0) {
      const symb = assignedSymbols[claimExistArray]?.symbol;
      setAppledSymbol(symb);
    }
  }, []);

  const symbolAssigned = (symbol) => {
    setAppledSymbol(symbol);
  };
  const cancelPopup = () => {
    // console.log("======= selected symbol add", relatedClaimsData);
    setOpenAssignPopup(false);
  };

  const isDraggable = (claimMatchText) => {
    const decodedString = new DOMParser().parseFromString(
      editor?.getHtml(),
      "text/html"
    ).documentElement.textContent;
    return decodedString
      .replace(/\s+/g, "")
      .includes(claimMatchText?.replace(/\s+/g, ""));
  };
  const relatedClaimAdded = (claimId) => {
    if (!editor) return false;
    const allComps = editor?.getWrapper();
    if (!allComps || typeof allComps.find !== "function") {
      return false;
    }
    try {
      if (allComps && claimId) {
        const claimRelatedOnEditor = allComps?.find(
          `[related-claim=${claimId}]`
        );
        return claimRelatedOnEditor?.length > 0 ? true : false;
      }
    } catch (err) {
      console.error("Error in wrapper.find:", err);
      return false;
    }
  };

  const parentClaimAdded = (claimId) => {
    if (!editor) return false;
    const allComps = editor?.getWrapper();
    if (!allComps || typeof allComps.find !== "function") {
      return false;
    }
    try {
      if (allComps && claimId) {
        const claimParentOnEditor = allComps?.find(`[parent-claim=${claimId}]`);
        return claimParentOnEditor?.length > 0 ? true : false;
      }
    } catch (err) {
      console.error("Error in wrapper.find:", err);
      return false;
    }
  };

  const grayout = (claimMatchText) => {
    const decodedString = new DOMParser().parseFromString(
      editor?.getHtml(),
      "text/html"
    ).documentElement.textContent;
    return decodedString
      .replace(/\s+/g, "")
      .includes(claimMatchText?.replace(/\s+/g, ""));
  };

  const dragMatch = (e, from) => {
    const relateClaimOnEditor = editor?.getWrapper().find(`sup`);
    console.log("===================", relateClaimOnEditor);
    if (from === "footnotes") {
      e.dataTransfer.setData("text", e.target.innerText);
    } else if (from === "ref") {
      const el = e.currentTarget;
      const clone = el.cloneNode(true);

      clone.querySelector("span")?.remove();

      e.dataTransfer.setData("text/plain", clone.textContent.trim());
    } else {
      e.dataTransfer.setData("text/html", e.target.lastChild.innerHTML);
    }
  };

  editor?.on("component:add", function (elem) {
    // console.log(claimsOnEditorAsset, "claimsOnEditorAsset");
    setCondition(!condition);
    // console.log("called", elem);
    const claimId = claim.claimName;
    if (!elem.getAttributes()["related-claim"]) return;

    //if it is parent claim
    if (!editor) return false;
    const allComps = editor?.getWrapper();
    if (!allComps || typeof allComps.find !== "function") {
      return false;
    }
    try {
      if (allComps) {
        debugger;
        const claimParentOnEditor = allComps?.find(
          `[parent-claim=${claim.claimName}]`
        );
        let symbolElements = "";
        for (var i = 0; i < claimParentOnEditor.length; i++) {
          symbolElements = claimParentOnEditor[i]?.find("sup");
        }
        // console.log("=========", symbolElements);

        if (symbolElements.length > 0) {
          symbolElements.forEach((symbolElement) => {
            if (
              elem.getAttributes()["related-claim"] ===
              symbolElement.getAttributes()["claim-id"]
            )
              symbolElement.setStyle({ display: "inline-block" });
            // console.log(symbolElement);
          });
        }
      }
    } catch (err) {
      console.error("Error in wrapper.find:", err);
      return false;
    }
  }); // added to re-render whole content in lhs while dropping/removing the text from editor

  editor.on("component:remove", (component) => {
    if (!component.getAttributes()["related-claim"]) return;
    const claimId = claim.claimName;
    const parent = component.parent();
    if (!parent || parent.is("wrapper")) return;

    //parent.remove();
    setCondition(!condition);
  });

  editor?.on("component:remove:before", function (elem) {
    //console.log(elem, "claimsOnEditorAsset");
    setClaimsOnEditorAsset(!claimsOnEditorAsset);
    if (!elem.getAttributes()["related-claim"]) return;
    const allComps = editor?.getWrapper();
    if (!allComps || typeof allComps.find !== "function") {
      return false;
    }
    const claimParentOnEditor = allComps?.find(
      `[parent-claim=${claim.claimName}]`
    );
    let symbolElements = "";
    for (var i = 0; i < claimParentOnEditor.length; i++) {
      symbolElements = claimParentOnEditor[i]?.find("sup");
    }
    // console.log("=========", symbolElements);

    if (symbolElements.length > 0) {
      symbolElements.forEach((symbolElement) => {
        if (
          elem.getAttributes()["related-claim"] ===
          symbolElement.getAttributes()["claim-id"]
        )
          symbolElement.setStyle({ display: "none" });
        // console.log(symbolElement);
      });
    }
  });

  return (
    <div className="accordion-item">
      <button className="accordion-header" onClick={onClick}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "18px", // 👈 fixed width for icon so it doesn't change size
              display: "inline-block",
              textAlign: "center",
              backgroundColor: isOpen ? "#F0F5F8" : "",
              color: isOpen ? "#203662" : "",
              fontSize: isOpen ? "14px" : "18px",
              fontWeight: isOpen ? "100" : "",
              cursor: "pointer",
              lineHeight: isOpen ? 1.3 : 1,
              height: "18px",
              borderRadius: "4px",
            }}
          >
            {isOpen ? (
              <span className="minusIcon22">−</span>
            ) : (
              <span className="plusIcon22">+</span>
            )}{" "}
          </div>
          <span
            style={{
              fontSize: "12px",
              marginLeft: "6px",
            }}
          >
            {title}
          </span>

          {item && (
            <div
              className="parentModulebox"
              style={{
                backgroundColor: item.mustUse === true ? "#E32B35" : "#378A05",
                marginLeft: "10px",
              }}
            ></div>
          )}
        </div>
        <div
          className="edit-claim-block"
          onClick={(e) => {
            e.stopPropagation();
            setOpenAssignPopup(true);
          }}
        >
          {appliedSymbol !== null && (
            <div
              className={`symbol-icon`}
              style={{
                fontSize: exceptionSymbols.includes(appliedSymbol)
                  ? "15px"
                  : "11px",
                fontFamily: [
                  "I",
                  "II",
                  "III",
                  "IV",
                  "V",
                  "VI",
                  "VII",
                  "VIII",
                  "IX",
                  "X",
                ].includes(appliedSymbol)
                  ? `"Times New Roman', serif"`
                  : `"Nunito Sans", sans-serif`,
              }}
            >
              {appliedSymbol}
            </div>
            /*  <div className={`symbol-icon`} style={{fontSize : exceptionSymbols.includes(appliedSymbol)?'15px':'11px'}}>{appliedSymbol}</div> */
          )}

          {/*            {appliedSymbol !== null && <div className={`symbol-icon`}>{assignedSymbols?.filter((id) => id.relatedClaimId === title)[0]?.symbol.trim() || appliedSymbol !== null && appliedSymbol}</div>}
           */}
          <div>{appliedSymbol !== null ? "Edit" : "Assign Claim"} symbol</div>
        </div>
      </button>
      {isOpen && (
        <div
          className={`accordion-content ${
            !parentClaimAdded(claim.claimName)
              ? "restrict_section"
              : "falseclass"
          }`}
        >
          {/* start */}
          <div className="matchText">Match Text </div>
          <div
            //className="d-flex draggableText"
            className={` d-flex draggableText 
                   ${
                     appliedSymbol == null || relatedClaimAdded(title)
                       ? "grayOut"
                       : ""
                   }`}
            draggable={appliedSymbol !== null && !relatedClaimAdded(title)}
            onDragStart={(e) => dragMatch(e)}
            onDragEnd={(e) => {
              setClaimsOnEditorAsset(!claimsOnEditorAsset);
              setCondition(
                appliedSymbol == null || isDraggable(item.matchText)
              );
            }}
          >
            <img src={sixDotIcon} alt="" className="img-fluid sixdotIcon" />
            <div className="textvariant">
              {item.matchText && (
                <div
                  module-claim={moduleClaimsData?.moduleDamName}
                  related-claim={title}
                  className="parent-claim"
                >
                  <sup className="hide-Lhs-sup" claim-id={title}>
                    {appliedSymbol}
                  </sup>
                  {item.matchText}
                </div>
              )}
            </div>
          </div>
          <>
            {item.matchTextVariants?.map((content, index) => {
              return (
                <>
                  <div className="matchText">{`Match Text Variant ${
                    index + 1
                  }`}</div>
                  <div
                    // className="d-flex draggableText"
                    className={`d-flex draggableText" ${
                      appliedSymbol == null || relatedClaimAdded(title)
                        ? "grayOut"
                        : ""
                    }`}
                    draggable={
                      appliedSymbol !== null && !relatedClaimAdded(title)
                    }
                    onDragStart={(e) => dragMatch(e)}
                    onDragEnd={(e) => {
                      setClaimsOnEditorAsset(!claimsOnEditorAsset);
                      setCondition(
                        appliedSymbol == null || isDraggable(content.matchText)
                      ); // added to re-render
                    }}
                  >
                    <img
                      src={sixDotIcon}
                      alt=""
                      className="img-fluid sixdotIcon"
                    />
                    <div className="textvariant">
                      {content.matchText && (
                        <div
                          module-claim={moduleClaimsData?.moduleDamName}
                          related-claim={title}
                          className="parent-claim"
                        >
                          <sup className="hide-Lhs-sup" claim-id={title}>
                            {appliedSymbol}
                          </sup>
                          {content.matchText}
                        </div>
                      )}
                    </div>
                  </div>
                </>
              );
            })}
          </>
          {item.footnotes?.length > 0 && (
            <div className="matchText1 ">Footnotes </div>
          )}
          <div
            //className="textvariant1 draggableText"
            className={`textvariant1 draggableText  ${
              appliedSymbol == null || grayout(item.footnotes) ? "grayOut" : ""
            }`}
            draggable={appliedSymbol !== null && !isDraggable(item.footnotes)}
            onDragStart={(e) => dragMatch(e, "footnotes")}
            onDragEnd={(e) => {
              setClaimsOnEditorAsset(!claimsOnEditorAsset);
              setCondition(
                appliedSymbol == null || isDraggable(item.footnotes)
              ); // added to re-render
            }}
          >
            {item.footnotes}
          </div>
          {item.references?.length > 0 && (
            <div className="matchText1">References</div>
          )}
          {item.references?.map((cont, index) => {
            return (
              <>
                <div
                  //className="textvariant1 draggableText"
                  className={`textvariant1 draggableText  ${
                    appliedSymbol == null || grayout(cont.documentName)
                      ? "grayOut"
                      : ""
                  }`}
                  draggable={
                    appliedSymbol !== null && !isDraggable(cont.documentName)
                  }
                  onDragStart={(e) => dragMatch(e, "ref")}
                  onDragEnd={(e) => {
                    setClaimsOnEditorAsset(!claimsOnEditorAsset);
                    setCondition(
                      appliedSymbol == null || isDraggable(cont.documentName)
                    ); //// added to re-render
                  }}
                >
                  {" "}
                  <span>{index + 1}.{" "}</span>
                  {`${cont.documentName}`}
                </div>
              </>
            );
          })}
          {/* end */}
        </div>
      )}

      {OpenAssignPopup && (
        <CustomModal
          displayModal={OpenAssignPopup}
          hideModal={() => {
            setOpenAssignPopup(false);
          }}
          title={""}
          size="xl"
          dilogClassName="detail-informations-modal assignSymbolModal"
        >
          <AssignsymbolPopup
            OpenAssignPopup={OpenAssignPopup}
            setOpenAssignPopup={setOpenAssignPopup}
            footnoteSymbols={footnoteSymbols}
            symbolAssigned={symbolAssigned}
            cancelPopup={cancelPopup}
            item={item}
            claim={claim}
            moduleClaimsData={moduleClaimsData}
            setAppledSymbol={setAppledSymbol}
            relatedClaimsData={relatedClaimsData}
            setRelatedClaimsData={setRelatedClaimsData}
            setPreviewLoading={setPreviewLoading}
            setAssignedSymbols={setAssignedSymbols}
            editor={editor}
            appliedSymbol={appliedSymbol}
            previewLoading={previewLoading}
          />
        </CustomModal>
      )}
    </div>
  );
};

const AccordionClaim = ({
  relatedClaims,
  claim,
  customDrag,
  setClaimsOnEditorAsset,
  editor,
  claimsOnEditorAsset,
  moduleClaimsData,
  assignedSymbols,
  setAssignedSymbols,
  setPreviewLoading,
  previewLoading,
}) => {
  const [openIndex, setOpenIndex] = useState(null);
  const [relatedClaimsData, setRelatedClaimsData] = useState([]);
  const [symbolsObjData, setSymbolsObjData] = useState({});
  const { pageId } = useParams();
  useEffect(() => {
    // console.log("assigned aray", assignedSymbols);
    setRelatedClaimsData(assignedSymbols);
    setPreviewLoading(false);
  }, []);
  const handleClick = (index) => {
    // If clicked item is already open, close it; otherwise, open the new one
    setOpenIndex(index === openIndex ? null : index);
  };

  return (
    <div className="accordion">
      {!previewLoading &&
        assignedSymbols !== null &&
        relatedClaimsData !== null &&
        relatedClaims.map((item, index) => (
          <AccordionItem
            key={index}
            title={item.claimName}
            content={item.footnotes}
            isOpen={openIndex === index}
            onClick={() => handleClick(index)}
            claim={claim}
            customDrag={customDrag}
            setClaimsOnEditorAsset={setClaimsOnEditorAsset}
            editor={editor}
            moduleClaimsData={moduleClaimsData}
            item={item}
            relatedClaimsData={relatedClaimsData}
            setRelatedClaimsData={setRelatedClaimsData}
            assignedSymbols={assignedSymbols}
            setPreviewLoading={setPreviewLoading}
            previewLoading={previewLoading}
            setAssignedSymbols={setAssignedSymbols}
          />
        ))}
    </div>
  );
};

export default AccordionClaim;
